import _ from 'lodash';
import { NOTIFICATIONS_RESOURCE } from '../resources/notifications.resource';
import { currentUserSelector } from '../selectors/auth.selectors';
import { shouldFetchSelector } from '../selectors/fetch.selectors';
import { tableDataSelector } from '../selectors/resources.selectors';
import notificationsService from '../services/api/notifications.service';
import { resourceUpdate } from './resources.actions';
import { fetchForTable } from './table.actions';

const resource = NOTIFICATIONS_RESOURCE;

const getForCurrentUser = (size = 50) => {
  return (dispatch, getState) => {
    const shouldFetch = shouldFetchSelector(getState(), { resource });

    if (!shouldFetch) {
      return;
    }

    dispatch(fetchForTable(resource, { size }));
  };
};

const setReceivedNotifications = (notifications) => {
  return (dispatch, getState) => {
    const state = getState();
    const user = currentUserSelector(state);
    const data = tableDataSelector(state, { resource })?.data ?? [];
    const notificationsForCurrentUser = notifications?.filter((n) => n.contactId === user?.contactId) ?? [];

    if (!notificationsForCurrentUser.length) {
      return;
    }

    dispatch(
      resourceUpdate(
        NOTIFICATIONS_RESOURCE,
        'data',
        _.sortBy(
          _.uniqBy([...(data || []), ...notificationsForCurrentUser], (a) => a.id),
          (a) => a.createdAt
        ).reverse()
      )
    );
  };
};

const acknowledge = () => {
  return (dispatch, getState) => {
    const state = getState();
    const data = tableDataSelector(state, { resource })?.data ?? [];

    const toAcknowledge = data?.filter((n) => !n.acknowledged);

    if (!toAcknowledge.length) {
      return;
    }

    dispatch(
      resourceUpdate(
        NOTIFICATIONS_RESOURCE,
        'data',
        data?.map((n) => ({ ...n, acknowledged: true }))
      )
    );
    notificationsService.acknowledge(toAcknowledge?.map((n) => n.id));
  };
};

const notificationsActions = {
  getForCurrentUser,
  setReceivedNotifications,
  acknowledge
};

export default notificationsActions;
